/**
 * Ephemeral store for upsell attribution data that needs to survive a page
 * navigation (e.g. Ask thread -> /computer).
 *
 * Uses SafeSessionStorage so the value persists across router.push() but is
 * automatically cleared when the tab closes (matching the codebase pattern
 * used by ORG_ONBOARDING_SUCCESS_REDIRECT_KEY and similar cross-page state).
 *
 * Set by `useQueryFillParams` when `qrquuid` is present in URL params,
 * or by `useOnClickRelated` when any prefill-style related-query chip is
 * clicked (COMPUTER_FOLLOWUP, deep-research upsell, agentic-research upsell,
 * etc.).
 * Consumed (and cleared) by `useComputerTaskSubmitter` (new-task navigation)
 * or `ThreadFloatingFooter` (in-thread follow-up/upsell submit) on the next
 * submit so the resulting query carries the attribution back to the backend.
 */
import { SafeSessionStorage } from '#pplx/frontend/browser-storage/sessionStorage.js';
const QFILL_ATTRIBUTION_KEY = 'pplx.qfillAttribution.relatedQueryUUID';
export function setQFillAttribution(uuid) {
    SafeSessionStorage.setItem(QFILL_ATTRIBUTION_KEY, uuid);
}
export function consumeQFillAttribution() {
    const uuid = SafeSessionStorage.getItem(QFILL_ATTRIBUTION_KEY);
    if (uuid) {
        SafeSessionStorage.removeItem(QFILL_ATTRIBUTION_KEY);
    }
    return uuid;
}
//# sourceMappingURL=qfillAttribution.js.map